/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TestStatus {
  Active = 'Active',
  Started = 'Started',
  Submitted = 'Submitted',
  Completed = 'Completed',
  Expired = 'Expired',
}
